<script setup lang="ts">
import { computed } from 'vue'
import { FairIcon } from '@/ui/primitives/FairIcon'
import type { FairCheckboxPreviewState } from '@/ui/tokens/checkbox.data'

interface FairCheckboxIndicatorProps {
  checked?: boolean
  /** Parent partially selected — filled box + dash (Category tree). */
  indeterminate?: boolean
  disabled?: boolean
  previewState?: FairCheckboxPreviewState
}

const props = withDefaults(defineProps<FairCheckboxIndicatorProps>(), {
  checked: false,
  indeterminate: false,
  disabled: false,
  previewState: undefined,
})

const isFilled = computed(() => props.checked || props.indeterminate)

const indicatorClass = computed(() => ({
  'fair-checkbox-indicator': true,
  'fair-checkbox-indicator--checked': isFilled.value,
  'fair-checkbox-indicator--indeterminate': props.indeterminate,
  'fair-checkbox-indicator--disabled':
    props.disabled || props.previewState === 'disabled',
  [`fair-checkbox-indicator--preview-${props.previewState}`]: Boolean(props.previewState),
}))
</script>

<template>
  <span
    :class="indicatorClass"
    aria-hidden="true"
  >
    <span
      v-if="indeterminate"
      class="fair-checkbox-indicator__dash"
    />
    <FairIcon
      v-else-if="checked"
      name="check"
      :size="12"
      color="currentColor"
    />
  </span>
</template>
